/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Save_Aborted_ToastInputs */

const en_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save preset aborted.`)
};

const fr_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du preset annule.`)
};

const de_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern der Voreinstellung abgebrochen.`)
};

const it_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio predefinito interrotto.`)
};

const ru_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение настроек прервано.`)
};

const es_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se interrumpió el guardado del ajuste preestablecido.`)
};

const zh_cn2_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存预设已中止。`)
};

const ja_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットの保存が中止されました。`)
};

const hi_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सेव करने की प्रक्रिया रद्द कर दी गई।`)
};

const pt_pt2_styles_save_aborted_toast = /** @type {(inputs: Styles_Save_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvamento da predefinição cancelado.`)
};

/**
* | output |
* | --- |
* | "Save preset aborted." |
*
* @param {Styles_Save_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_save_aborted_toast = /** @type {((inputs?: Styles_Save_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Save_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_save_aborted_toast(inputs)
	if (locale === "de") return de_styles_save_aborted_toast(inputs)
	if (locale === "it") return it_styles_save_aborted_toast(inputs)
	if (locale === "ru") return ru_styles_save_aborted_toast(inputs)
	if (locale === "es") return es_styles_save_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_save_aborted_toast(inputs)
	if (locale === "ja") return ja_styles_save_aborted_toast(inputs)
	if (locale === "hi") return hi_styles_save_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_save_aborted_toast(inputs)
	return en_styles_save_aborted_toast(inputs)
});